import React from 'react';

/**
 * Static SEO statement above the header. Not sticky, muted, and capped at two lines on a phone.
 */
export function SeoStatement() {
  return <div className="w-full border-b border-white/[0.07] bg-navy-950" data-id="element-351" data-mp="3pn1wmm8256kb">
      <div className="mx-auto max-w-8xl px-5 py-2.5 sm:px-8 lg:px-10" data-id="element-352" data-mp="3tpy8zv7086ft">
        <p className="text-center text-[11.5px] leading-snug text-mist-400 sm:text-[12px]" data-id="element-353" data-mp="2clst3c3uop0">
          <span className="sm:hidden" data-id="element-354" data-mp="7bf36mw3hzky">
            Custom websites, ecommerce, SEO, integrations, hosting, and ongoing management.
          </span>
          <span className="hidden sm:inline" data-id="element-355" data-mp="c8ovcaavcpch">
            Custom websites, ecommerce, SEO, Google Ads support, lead generation, integrations, hosting, and ongoing website
            management.
          </span>
        </p>
      </div>
    </div>;
}